'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderDetailProductsComponent = exports.orderDetailProductsComponent = {
    template: require('./order-detail-products.html'),
    bindings: {
        order: '<'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.getDiscountPrice = getDiscountPrice;

        /* Get the discount price */
        function getDiscountPrice(unitPrice, discountPercentage) {
            return unitPrice - unitPrice * discountPercentage / 100;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/account/components/order-detail-products.js
// module id = 843
// module chunks = 0